import { FC } from "react";
import { NativeDropdownOptionProps } from "../interface";

const NativeDropdownOptions: FC<NativeDropdownOptionProps> = ({
  items,
  placeholder,
  className,
}) => (
  <>
    {placeholder && (
      <option hidden value="" className={className}>
        {placeholder}
      </option>
    )}
    {items.map(({ id, value, label, lang }) => (
      <option
        key={id}
        value={value}
        data-auto="eb-native-dropdown-option"
        className={className}
        lang={lang}
      >
        {label}
      </option>
    ))}
  </>
);

export default NativeDropdownOptions;
